// Prevent multiple script loading
if (!window.SplitFulfillmentLoaded) {
  window.SplitFulfillmentLoaded = true;

const shippingThreshold = 99;
let isUpdating = false;
let debug = false;

function log(...args) {
  if (debug) {
    console.log('[SplitFulfillment]', ...args);
  }
}

async function updateCartItemProperty(lineItemKey, propertyValue, itemQty) {
  const data = {
    id: lineItemKey,
    properties: {
      _Split_Fulfillment_Order: propertyValue
    },
    quantity: itemQty
  };

  log('Updating item:', lineItemKey, 'to:', propertyValue);

  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    throw new Error('Failed to update cart item');
  }

  return response.json();
}

async function fetchCart() {
  const response = await fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Accept': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch cart');
  }

  return response.json();
}

async function updateSplitFulfillment() {
  if (isUpdating) {
    log('Update already in progress, skipping');
    return;
  }

  isUpdating = true;

  try {
    const cart = await fetchCart();
    
    // Calculate subtotal in dollars
    const subtotal = cart.items.reduce((total, item) => total + item.final_line_price, 0) / 100;
    const newValue = subtotal >= shippingThreshold ? 'Y' : 'N';

    console.log(`Cart subtotal: ${subtotal}, Setting _Split_Fulfillment_Order to: ${newValue}`);

    // Log current state of all items
    cart.items.forEach(item => {
      const currentValue = item.properties._Split_Fulfillment_Order || 'undefined';
      console.log(`${item.title}: _Split_Fulfillment_Order = "${currentValue}" (should be "${newValue}")`);
    });

    // Filter items that need updating
    const itemsToUpdate = cart.items.filter(item => 
      item.properties._Split_Fulfillment_Order !== newValue
    );

    if (itemsToUpdate.length === 0) {
      console.log('✅ All items already have correct _Split_Fulfillment_Order values');
      return;
    }

    console.log(`Updating ${itemsToUpdate.length} items...`);

    // Update all items that need changes
    await Promise.all(
      itemsToUpdate.map(item => 
        updateCartItemProperty(item.key, newValue, item.quantity)
      )
    );

    console.log(`✅ Updated ${itemsToUpdate.length} items to "${newValue}"`);

  } catch (error) {
    console.error('Error updating cart:', error);
  } finally {
    isUpdating = false;
  }
}

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

const debouncedUpdate = debounce(updateSplitFulfillment, 300);

// Public debug interface
window.SplitFulfillmentDebug = {
  enable() {
    debug = true;
    console.log('Debug mode enabled');
  },
  disable() {
    debug = false;
    console.log('Debug mode disabled');
  },
  async update() {
    return await updateSplitFulfillment();
  }
};

// ============================================
// INITIALIZATION - IMPROVED FOR RELIABILITY
// ============================================

function initSplitFulfillment() {
  log('Initializing split fulfillment script');
  
  // Run initial update
  updateSplitFulfillment();

  // Quantity adjustment buttons (+ and -)
  document.addEventListener('click', (event) => {
    if (event.target.matches('.js-qty__adjust') || 
        event.target.closest('.js-qty__adjust')) {
      log('Quantity button clicked');
      debouncedUpdate();
    }
  });

  // Quantity input field - input event for real-time changes
  document.addEventListener('input', (event) => {
    if (event.target.matches('.js-qty__num') || 
        event.target.matches('input[name*="updates"]')) {
      log('Quantity input changed');
      debouncedUpdate();
    }
  });

  // Quantity input field - change event as backup
  document.addEventListener('change', (event) => {
    if (event.target.matches('.js-qty__num') || 
        event.target.matches('input[name*="updates"]')) {
      log('Quantity changed');
      debouncedUpdate();
    }
  });

  // Add to cart buttons
  document.addEventListener('click', (event) => {
    if (event.target.matches('[data-add-to-cart]') || 
        event.target.closest('[data-add-to-cart]') ||
        event.target.matches('.product-form__submit') ||
        event.target.closest('.product-form__submit')) {
      log('Add to cart clicked');
      setTimeout(updateSplitFulfillment, 500);
    }
  });

  // Cart drawer/page specific events
  document.addEventListener('cart:updated', () => {
    log('Cart updated event');
    debouncedUpdate();
  });

  // Theme-specific cart refresh events (common patterns)
  document.addEventListener('theme:cart:change', () => {
    log('Theme cart change event');
    debouncedUpdate();
  });

  // Shopify Section Rendering API (for dynamic cart updates)
  if (window.Shopify && window.Shopify.theme && window.Shopify.theme.cart) {
    const originalUpdate = window.Shopify.theme.cart.update;
    if (originalUpdate) {
      window.Shopify.theme.cart.update = function(...args) {
        log('Shopify cart update intercepted');
        const result = originalUpdate.apply(this, args);
        setTimeout(updateSplitFulfillment, 300);
        return result;
      };
    }
  }

  // Ajax API cart change monitoring (Shopify Ajax Cart API)
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    if (typeof url === 'string' && 
        (url.includes('/cart/add') || 
         url.includes('/cart/change') || 
         url.includes('/cart/update'))) {
      log('Cart fetch intercepted:', url);
      return originalFetch.apply(this, args).then(response => {
        if (response.ok) {
          setTimeout(updateSplitFulfillment, 300);
        }
        return response;
      });
    }
    return originalFetch.apply(this, args);
  };

  log('Split fulfillment script loaded and listeners attached');
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSplitFulfillment);
} else {
  // DOM already loaded
  initSplitFulfillment();
}

// Re-run on Shopify section re-renders (for cart drawer)
document.addEventListener('shopify:section:load', (event) => {
  if (event.detail && event.detail.sectionId && 
      (event.detail.sectionId.includes('cart') || 
       event.detail.sectionId.includes('drawer'))) {
    log('Cart section reloaded');
    setTimeout(updateSplitFulfillment, 500);
  }
});

} // End of SplitFulfillmentLoaded check